import React from 'react'

function ContactForm() {

       const submitHandler = (e) => {
        e.preventDefault()
    }

  return (
    <div>

      <div className=" mt-5">
 <section className="wpo-blog-single-section">
            <div className="container">
                <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-12 text-start">
                    
                    <section className="wpo-contact-pg-section">
                        
                    <div className="office-info">
                        
                                    <div className="office-info-item text-start h-100">
                                         <div className="section-title text-start mb-0">
                            <h2 className='fs-1' style={{color:'#FBB132'}}>Contact Us</h2>
                            <p className=''>Have a project in mind or need expert IT consulting? Our team is ready to answer your questions and provide the right solutions for your business. </p>
                        </div>
                                        {/* <div className="office-info-icon ms-0">
                                            <div className="icon">
                                                <i className="fi flaticon-placeholder"></i>
                                            </div>
                                        </div> */}
                                      
                                        <div className="office-info-text">
                                            <h2 className='' style={{color:"#7DC370"}}>E-mail</h2>
                                            <p><a href="mailto:info@faxianit.com" className='text-dark fs-4'>info@faxianit.com</a></p>
                                        </div>
                                        <div className="office-info-text">
                                            <h2 className='' style={{color:"#7DC370"}}>Call Us</h2>
                                            <p><a href="tel:+1 (424) 242-2277" className='text-dark fs-4'>+1 (424) 242-2277</a></p>
                                        </div>
                                          <div className="office-info-text">
                                            <h2 className='' style={{color:"#7DC370"}}>Address</h2>
                                            <p className=''>FaxianIT Inc. 4320 Winfield Road, Suite 200 Cornerstone @ Cantera Warrenville Illinois 60555 United States of America</p>
                                        </div>
                                    </div>
                                </div>
                                </section>



                                
                                </div>



                  <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
  <div className="wpo-blog-content">
           <div className="comments-area">
                <div className="comment-respond ">
                                    <h1 className="comment-reply-title fs-1 mb-0"  style={{color:'#FBB132'}}>GET IN TOUCH</h1>
                                    <p className=''>We’re here to help you accelerate your digital journey.</p>
                                    <form onSubmit={submitHandler} id="commentform" className="comment-form">
                                        
                                        <div className="form-inputs">
                                            <input placeholder="Name" type="text" name='name' />
                                            <input placeholder="Phone Number" type="text" name='phone' />
                                            <input placeholder="Email" type="email" name='email' />
                                            <input placeholder="Subject" type="text"  name='subject'/>
                                        </div>
                                        <div className="form-textarea">
                                            <textarea id="message" placeholder="How can we help"></textarea>
                                        </div>
                                        <div className="form-submit" >
                                            <input id="submit" style={{background:'#FBB132'}} value="Send Message" type="submit" />
                                        </div>
                                    </form>
                                </div>
                          </div>
                          </div>
                        </div>
                        </div>
                        </div>
                        </section>
    </div>  
      
    </div>
  )
}

export default ContactForm
